module.exports = __webpack_public_path__ + "staticcomp/img/content_1.8e542af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/6/content_1.jpg
// module id = Nc83
// module chunks = 39